import './App.css';
import Main from './Main';

export default function App() {
  return (
    <main>
      <div className="app">
        <Main />
      </div>
    </main>
  );
}
